export const ChatActionTypes = {
  API_RESPONSE_SUCCESS: '@@chat/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@chat/API_RESPONSE_ERROR',

  GET_USUARIO: '@@chat/GET_USUARIO',
  LIST_SALAS: '@@chat/LIST_SALAS',
  LIST_USUARIOS: '@@chat/LIST_USUARIOS',
  LIST_USUARIOS_IN_SALA: '@@chat/LIST_USUARIOS_IN_SALA',
  LIST_MSG: '@@chat/LIST_MSG',
  ADD_MSG: '@@chat/ADD_MSG',
  GET_NOTIFICATIONS: '@@chat/GET_NOTIFICATIONS',
  UPDATE_PINNED: '@@chat/UPDATE_PINNED',
  UPDATE_NOTIFICATIONS: '@@chat/UPDATE_NOTIFICATIONS',
  MISSING_MSG: '@@chat/MISSING_MSG',
  DELETE_MSG: '@@chat/DELETE_MSG',

  CREATE_FOLDER: '@@chat/CREATE_FOLDER',
  DELETE_FILE: '@@chat/DELETE_FILE',
  LIST_FILES: '@@chat/LIST_FILES',
  UPLOAD_FILE: '@@chat/UPLOAD_FILE',
  DOWNLOAD_FILE: '@@chat/DOWNLOAD_FILE',

  LIST_EVENTOS_CALENDARIO: '@@chat/LIST_EVENTOS_CALENDARIO',
  CREATE_EVENTO_CALENDARIO: '@@chat/CREATE_EVENTO_CALENDARIO',
  UPDATE_EVENTO_CALENDARIO: '@@chat/UPDATE_EVENTO_CALENDARIO',
  DELETE_EVENTO_CALENDARIO: '@@chat/DELETE_EVENTO_CALENDARIO',

  SET_FILTER: '@@chat/SET_FILTER',

  RESET: '@@chat/RESET',
  RESET_MSG: '@@chat/RESET_MSG',
  RESET_EVENTOS: '@@chat/RESET_EVENTOS'
}
